export default __webpack_public_path__ + "static/media/onboarding_level_mobile.b2ae0956.png";